import React from "react";
import { useLang } from "../lib/LangContext";
import { Wallet, Ticket, TrendingUp, Camera, Shield, Users } from "lucide-react";

const ICONS = [Wallet, Ticket, TrendingUp, Camera, Shield, Users];

const Benefits = () => {
  const { t } = useLang();

  return (
    <section
      id="benefits"
      data-testid="benefits-section"
      className="relative bg-black py-20 md:py-28"
    >
      {/* dotted bg accent */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage: "radial-gradient(#FFD60A 1px, transparent 1px)",
          backgroundSize: "28px 28px",
        }}
      />
      <div className="relative max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 mb-12">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <div className="h-px w-8 bg-brand-yellow" />
              <span className="text-[11px] uppercase tracking-[0.4em] text-brand-yellow font-semibold">
                {t.benefits.eyebrow}
              </span>
            </div>
            <h2 className="font-anton uppercase text-white leading-[0.95]" style={{ fontSize: "clamp(2rem, 4.5vw, 3.75rem)" }}>
              {t.benefits.title}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10">
          {t.benefits.list.map((b, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={i}
                data-testid={`benefit-card-${i}`}
                className="group relative bg-black p-6 md:p-8 hover:bg-[#0a0a0a] transition-all duration-300"
              >
                <div className="flex items-start justify-between mb-5">
                  <div className="w-11 h-11 border border-brand-yellow/40 flex items-center justify-center group-hover:bg-brand-yellow group-hover:border-brand-yellow transition-all">
                    <Icon size={20} className="text-brand-yellow group-hover:text-black transition-colors" strokeWidth={1.5} />
                  </div>
                  <span className="font-anton text-white/15 text-2xl group-hover:text-brand-yellow/40 transition-colors">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-anton uppercase text-lg md:text-xl text-white mb-2 tracking-wide">
                  {b.t}
                </h3>
                <p className="text-white/60 leading-relaxed text-sm">{b.d}</p>
                <div className="absolute bottom-0 left-0 h-px bg-brand-yellow w-0 group-hover:w-full transition-all duration-500" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
